import React, {useState} from 'react';
import {
  FaHome,
  FaGamepad,
  FaWallet,
  FaUser,
  FaCrown,
  FaMoneyBill,
  FaPrint,
} from 'react-icons/fa';
import './BottomTabs.css';
import {useNavigate} from 'react-router-dom';

const tabs = [
  {id: 'home', label: 'All', icon: <FaPrint />, path: '/passbook'},
  {id: 'play', label: 'Play Game', icon: <FaGamepad />, path: '/playHistory'},
  {
    id: 'play',
    label: 'Add Money',
    icon: <FaMoneyBill />,
    path: '/AddMoneyList',
  },
  {id: 'wallet', label: 'Withdraw', icon: <FaWallet />, path: '/WithdrawList'},
  {id: 'profile', label: 'Win', icon: <FaCrown />, path: '/win'},
];

const MoreBottomTab = () => {
  const [activeTab, setActiveTab] = useState('');
  const navigate = useNavigate();

  const handleTabClick = tab => {
    setActiveTab(tab.id);
    navigate(tab.path);
  };

  return (
    <>
      <div className="appContainer">
        <div className="bottomTabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className="tabButton"
              onClick={() => handleTabClick(tab)}>
              <div className="tabIcon">{tab.icon}</div>
              <div className="tabLabel">{tab.label}</div>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default MoreBottomTab;
